import ProductCardDesktop from './ProductCardDesktop';

export default ProductCardDesktop;
